var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgDocPrefix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C4.3125 0 3.75 0.5625 3.75 1.25V18.75C3.75 19.4375 4.3125 20 5 20H17.5C18.1875 20 18.75 19.4375 18.75 18.75V5L13.75 0H5Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H18.75L13.75 0V3.75C13.75 4.4375 14.3125 5 15 5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.75L15 5H18.75V8.75Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.25C16.25 16.5938 15.9688 16.875 15.625 16.875H1.875C1.53125 16.875 1.25 16.5938 1.25 16.25V10C1.25 9.65625 1.53125 9.375 1.875 9.375H15.625C15.9688 9.375 16.25 9.65625 16.25 10V16.25Z",
    fill: "#50BEE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61648 14.9972C3.45148 14.9972 3.27148 14.9066 3.27148 14.6872V11.8491C3.27148 11.6691 3.45148 11.5391 3.61648 11.5391H4.76086C7.04461 11.5391 6.99398 14.9972 4.80523 14.9972H3.61648ZM3.93148 12.1484V14.3872H4.76086C6.11023 14.3872 6.16961 12.1484 4.76086 12.1484H3.93148Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90586 15.0472C7.98148 15.0872 7.02148 14.4722 7.02148 13.2478C7.02148 12.0184 7.98086 11.4141 8.90586 11.4141C9.78023 11.4584 10.6946 12.0634 10.6946 13.2478C10.6946 14.4328 9.78023 15.0472 8.90586 15.0472ZM8.85086 12.0641C8.29086 12.0641 7.68148 12.4591 7.68148 13.2484C7.68148 14.0334 8.29148 14.4334 8.85086 14.4334C9.42586 14.4334 10.0402 14.0334 10.0402 13.2484C10.0402 12.4584 9.42586 12.0641 8.85086 12.0641Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2832 13.2391C11.2832 12.2747 11.8882 11.4453 13.0376 11.4453C13.4726 11.4453 13.8176 11.5753 14.182 11.8903C14.317 12.0147 14.332 12.2347 14.197 12.3747C14.062 12.4941 13.857 12.4797 13.737 12.3597C13.5326 12.1447 13.3226 12.0853 13.0376 12.0853C12.2682 12.0853 11.8988 12.6303 11.8988 13.2397C11.8988 13.8597 12.2632 14.4291 13.0376 14.4291C13.3226 14.4291 13.5876 14.3134 13.8176 14.1091C13.972 13.9891 14.187 14.0484 14.277 14.1691C14.357 14.2791 14.3963 14.4641 14.222 14.6384C13.872 14.9641 13.4526 15.0291 13.037 15.0291C11.8282 15.0291 11.2832 14.2034 11.2832 13.2391Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 16.875H3.75V17.5H15.625C15.9688 17.5 16.25 17.2188 16.25 16.875V16.25C16.25 16.5938 15.9688 16.875 15.625 16.875Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgDocPrefix);
export default __webpack_public_path__ + "static/media/svg_doc_prefix.edf41831d15cd7f9a6cd2002fbc37c00.svg";
export { ForwardRef as ReactComponent };